import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IBulkAssignUsersDto } from "./types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IBulkAssignUsersDto
>("stores.warehouses.bulkAssignUsers");

export const bulkAssignUsers = {
  ...postApis,
};
